import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    switch (this.data.get("format")) {
      case "phone-number":
        var phone_behavior = function(val) {
            return val.replace(/\D/g, "").length === 11
              ? "(00) 00000-0000"
              : "(00) 0000-00009";
          },
          phone_options = {
            onKeyPress: function(val, e, field, options) {
              field.mask(phone_behavior.apply({}, arguments), options);
            }
          };

        $(this.element).mask(phone_behavior, phone_options);
        break;
      case "cpf-cnpj":
        var cnpj_behavior = function(val) {
          return val.length > 14 || val.length === 0
            ? '00.000.000/0000-00'
            : '000.000.000-000';
        },
        options = {
          onKeyPress: function (cpf, ev, el, op) {
              el.mask(cnpj_behavior, op);
          }
        }
        $(this.element).length > 14 || $(this.element).length === 0 ? $(this.element).mask(cnpj_behavior, options) : $(this.element).mask(cnpj_behavior, options);
        break;
      case "percentage":
        $(this.element)
          .mask(
            "#Z,ZZ",
            {
              translation:  {'Z': {pattern: /[0-9]/, optional: true}}
            }
          );
        break;
      default:
        const reverse = this.data.get("reverse")
          ? this.data.get("reverse")
          : false;

        $(this.element).mask(this.data.get("format"), { reverse: reverse });

        // select the whole value if the value is 0,00
        this.element.addEventListener("focus", function(e) {
          if (e.target.value === "0,00") {
            e.target.select();
          }
        });
    }
  }
}
